import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  loyaltyPageHeader: {
    padding: "0 0 32px 0px"
  },
  loyaltyHeaderText: {
    marginBottom: "24px"
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0px",
    marginBottom: "4px"
  },
  description: {
    color: colors.mediumGrey,
    margin: "4px 0 0 0"
  },
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
}));

export default styles;